import React from 'react';
import classnames from 'classnames';
import './HeatmapRetrieveSuccessScreen.css';

const RETRIEVE_SUCCESS_MESSAGE = 'The image is successfully retrieved.';

const HeatmapRetrieveSuccessScreen = (props) => {
  return (
    <div id="HeatmapRetrieveSuccessScreen_Container" className="HeatmapRetrieveSuccessScreen_Container">
      <div id="HeatmapRetrieveSuccessScreen_TopContainer" className="HeatmapRetrieveSuccessScreen_TopContainer">
        <div id="HeatmapRetrieveSuccessScreen_HeaderText" className="HeatmapRetrieveSuccessScreen_HeaderText">
          Success!
        </div>
        <div
          id="HeatmapRetrieveSuccessScreen_MessageText"
          className="HeatmapRetrieveSuccessScreen_MessageText"
          data-tip={RETRIEVE_SUCCESS_MESSAGE}
        >
          {RETRIEVE_SUCCESS_MESSAGE}
        </div>
      </div>
      <div id="HeatmapRetrieveSuccessScreen_BottomContainer" className="HeatmapRetrieveSuccessScreen_BottomContainer">
        <button
          id="HeatmapRetrieveSuccessScreen_Bottom_CancelButton"
          className={classnames({
            HeatmapRetrieveSuccessScreen_Bottom_CancelButton: true
            // HeatmapRetrieveSuccessScreen_Bottom_CancelButton_Disabled: isFetching
          })}
          onClick={() => {
            props.onClose();
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default React.memo(HeatmapRetrieveSuccessScreen);
